import { render, staticRenderFns } from "./SplitContent.vue?vue&type=template&id=8c78d604&scoped=true"
import script from "./SplitContent.vue?vue&type=script&lang=js"
export * from "./SplitContent.vue?vue&type=script&lang=js"
import style0 from "./SplitContent.vue?vue&type=style&index=0&id=8c78d604&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c78d604",
  null
  
)

export default component.exports